import React, { useState } from 'react'
import RequestDialog from '../../dialogs/RequestDialog'
import { Box, Button, MenuItem, Select } from '@mui/material'
import { basicRoleNameMap } from '../../utility/utils'
import { DataRemovalRequest } from 'infrastructure/api'
import { useNavigateTo } from 'infrastructure/routing'
import { useNotify } from 'shared/ui/Notify'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'
import { makeKiddomPostRequest } from 'infrastructure/api'

const DataRemovalButton = ({
  schoolID,
  districtID,
}: {
  schoolID?: number
  districtID?: string | number
}) => {
  const doRemoveData = useWithErrorNotification(
    { errorTitle: 'Error With Anonymize Request' },
    (requestBody: object) => {
      return makeKiddomPostRequest({
        kiddomPath: `/v1/sis/anonymizeuserdata/pushtoqueue`,
        requestBody,
      })
    },
  )
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('anonymize_all_user_data')
  const [role, setRole] = useState('')
  const [activityTitle, setActivityTitle] = useState('Anonymize All User Data')
  const buttonText = 'Cleanup User Data'
  const notify = useNotify()
  const navigate = useNavigateTo()

  const dataCleanupType: { [key: string]: string } = {
    'Anonymize All User Data': 'anonymize_all_user_data',
    'Anonymize User Data by Role': 'anonymize_user_data',
    'Delete All User Data': 'delete_all_user_data',
    'Delete User Data by Role': 'delete_user_data',
  }

  // title changes when activityTitle or role state updates, which updates the
  // title in the RequestDialog
  const title =
    'Are you sure you want to ' +
    activityTitle +
    ' ' +
    (role !== '' ? role : '') +
    ' in this ' +
    (schoolID ? 'school' : 'district') +
    '?'

  const isRoleEnabled = (testType: string): boolean => {
    return testType === 'anonymize_user_data' || testType === 'delete_user_data'
  }

  const onRoleSelected = (event: any) => {
    setRole(event.target.value)
  }

  const setCleanupType = (event: any) => {
    setActivityTitle(event.target.value)
    setType(dataCleanupType[event.target.value])
    if (!isRoleEnabled(dataCleanupType[event.target.value])) {
      setRole('')
    }
  }

  const submit = async () => {
    let body: DataRemovalRequest
    if (schoolID) {
      body = {
        school_id: Number(schoolID),
        type,
      }
    } else {
      body = {
        district_id: Number(districtID),
        type,
      }
    }

    if (isRoleEnabled(type)) {
      body.user_role = role
    }

    try {
      await doRemoveData(body)
    } catch (error) {
      setOpen(false)
      notify((error as Error).toString(), {
        type: 'error',
      })
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const redirect = () => {
    const filter = districtID
      ? `{"district":"${districtID}"}`
      : `{"school":"${schoolID}"}`
    navigate(`/users?filter=${filter}`)
  }
  const ableToSubmit = () => {
    // only allow student anonymization/deletion submission
    return isRoleEnabled(type) && role === 'student'
  }
  return (
    <>
      <Box display={'flex'} className={'center-items'}>
        <Button
          variant="outlined"
          color="primary"
          style={{ float: 'left' }}
          onClick={handleClickOpen}
          disabled={!ableToSubmit()}
        >
          {buttonText}
        </Button>
        <Box
          display={'flex'}
          className={'center-items'}
          style={{ float: 'right' }}
        >
          <span>Cleanup Type:</span>
          <Select value={activityTitle} onChange={setCleanupType}>
            {Object.keys(dataCleanupType).map((e) => (
              <MenuItem key={e} value={e}>
                {e}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {isRoleEnabled(type) && (
          <Box
            display={'flex'}
            className={'center-items'}
            style={{ float: 'right' }}
          >
            <span>Role:</span>
            <Select value={role} onChange={onRoleSelected}>
              {Object.keys(basicRoleNameMap).map((e) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </Box>
        )}
      </Box>
      <RequestDialog
        open={open}
        title={title}
        content={[]}
        submitRequest={submit}
        onClose={handleClose}
        redirect={redirect}
      />
    </>
  )
}

export default DataRemovalButton
